import { render, staticRenderFns } from "./mc-exercise-frame.vue?vue&type=template&id=5c7dda7c&scoped=true&"
import script from "./mc-exercise-frame.vue?vue&type=script&lang=js&"
export * from "./mc-exercise-frame.vue?vue&type=script&lang=js&"
import style0 from "./mc-exercise-frame.vue?vue&type=style&index=0&id=5c7dda7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7dda7c",
  null
  
)

export default component.exports